import {type AxiosResponse} from "axios";
import {get, put} from "../../../infrastructure/api";
import {
  type ConfigurationRequestDto,
  type ConfigurationResponseDto,
  type UserGroupDto,
  type UserTypeDto
} from "../types";
import {EditEndpoint} from "./endpoints";
import {type ApiResponse} from "../../../infrastructure/types";

export const edit = async (
  configuration: ConfigurationRequestDto,
  id: number
): Promise<AxiosResponse<ConfigurationResponseDto>> =>
  await put({endpoint: EditEndpoint.updateConfiguration(id), data: configuration});

export const uploadConfiguration = async (
  data: FormData,
  id: number
): Promise<ConfigurationResponseDto> =>
  await put({
    endpoint: EditEndpoint.uploadZip(id),
    data
  })?.then(res => res.data);

export const getConfiguration = async (
  id: number
): Promise<AxiosResponse<ApiResponse<ConfigurationResponseDto>>> =>
  await get({endpoint: EditEndpoint.getConfiguration(id)});

export const getUserTypes = async (): Promise<AxiosResponse<ApiResponse<UserTypeDto[]>>> =>
  await get({endpoint: EditEndpoint.userTypes});

export const getUserGroups = async (): Promise<AxiosResponse<ApiResponse<UserGroupDto[]>>> =>
  await get({endpoint: EditEndpoint.userGroups});
